import { render } from "./repair.vue?vue&type=template&id=3bd01e4a&scoped=true"
import script from "./repair.vue?vue&type=script&lang=js"
export * from "./repair.vue?vue&type=script&lang=js"

import "./repair.vue?vue&type=style&index=0&id=3bd01e4a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd01e4a"]])

export default __exports__